<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.branch.branch') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.branch.branch'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'branch-create' })"
            >
              {{ $t('administration.branch.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('administration.branch.search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner>
          <Table
            :columns="columns"
            :data="resources"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
            size="small"
          >
            <template slot-scope="{ row }" slot="is_head">
              <span v-if="row.is_head"
                ><i class="far fa-check-square text-primary"></i
              ></span>
              <span v-else
                ><i class="far fa-window-close text-danger"></i
              ></span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
                v-tooltip="$t('administration.branch.edit')"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                class="text-danger"
                @click.prevent="destroyBranch(row)"
                :disabled="row._deleting"
                v-tooltip="$t('administration.branch.delete')"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
        <div class="d-flex justify-content-between align-items-center p-15">
          
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'branch',
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('branch', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.branch.search
      },
      set (newValue) {
        this.$store.commit('branch/SET_SEARCH', newValue)
        this.$store.commit('branch/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('administration.branch.code'),
          key: 'branch_code',
          minWidth: 50
        },
        {
          title: this.$t('administration.branch.prefix'),
          key: 'prefix',
          minWidth: 60
        },
        {
          title: this.$t('administration.branch.name_kh'),
          key: 'branch_name_kh',
          minWidth: 100
        },
        {
          title: this.$t('administration.branch.name_en'),
          key: 'branch_name_en',
          minWidth: 100
        },
        {
          title: this.$t('administration.branch.phone'),
          key: 'phone',
          minWidth: 100
        },
        {
          title: this.$t('administration.branch.email'),
          key: 'email',
          minWidth: 120
        },
        {
          title: this.$t('administration.branch.facebook_page'),
          key: 'facebook_page',
          minWidth: 120
        },
        {
          title: this.$t('administration.branch.head_office'),
          slot: 'is_head',
          minWidth: 20,
          align: 'center'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('branch/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('branch/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'branch-edit',
        params: { id: record.branch_id }
      })
    },
    async destroyBranch (record) {
      if (
        await this.$confirmModal.danger(
          this.$t('administration.branch.are_you_sure_to_delete')
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('branch/destroy', record.branch_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'branch-create') {
      this.$store.commit('branch/RESET_STATE')
    }
    next()
  }
}
</script>
